import Vue from 'vue'
import vuex from 'vuex'
import axios from 'axios'
import moment from 'vue-moment'
import setup from './modules/setup'
import packages from './modules/packages'
import booking from './modules/booking'

Vue.use(moment)
Vue.use(axios)
Vue.use(vuex)

const _state = {
  lastMessage: '',
  lastError: '',
  refresh_counter: 1
}
const _getters = {
  hasLastError: state => state.lastError !== '',
  getLastError: state => state.lastError,
  getRefreshCounter: state => state.refresh_counter
}
const _actions = {
  increaseRefresh (commit) {
    commit('increaseRefresh', this.state.refresh_counter++)
  }
}
const _mutations = {
  setLastError: (state, payload) => (state.lastError = payload),
  clearLastError: state => (state.lastError = ''),
  increaseRefresh: (state, payload) => (state.refresh_counter = payload)
}

export default new vuex.Store({
  state: _state,
  getters: _getters,
  mutations: _mutations,
  actions: _actions,
  modules: {
    setup,
    packages,
    booking
  }
})
